import { Navigate } from "react-router-dom";
import { getToken } from "../services/auth";
import { jwtDecode } from "jwt-decode";

export default function InstituteRoute({ children }) {
  const token = getToken();
  if (!token) return <Navigate to="/login" />;

  try {
    const decoded = jwtDecode(token);
    if (decoded.role !== "institute") {
      return <Navigate to="/" />;
    }
    return children;
  } catch (err) {
    return <Navigate to="/login" />;
  }
}
